'use client';

import { MainLayout } from '@/layout/MainLayout';

export default function MainGroupLayout({ children }: { children: React.ReactNode }) {
  return <MainLayout>{children}</MainLayout>;
}
